import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';

@Component({
    selector: 'ui-kit-stepper',
    templateUrl: './stepper.component.html',
    styleUrl: './stepper.component.scss',
    standalone: false,
})
export class StepperComponent implements OnInit, OnChanges {
    @Input() steps: string[];
    @Input() currentStep: string;
    @Input() hasNavigation: boolean = false;
    @Input() canNavigate: boolean = false;
    @Input() isStepCompleted?: (stepName: string) => boolean;
    @Output() stepIndexChangeListener = new EventEmitter<number>();
    @Output() submit = new EventEmitter<void>();

    currentStepIndex: number;
    maxVisitedStepIndex: number = 0;

    ngOnInit(): void {
        this.currentStepIndex = this.steps.findIndex(step => this.currentStep === step);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.steps && !changes.steps.firstChange) {
            const prev: string[] = changes.steps.previousValue;
            const curr: string[] = changes.steps.currentValue;
            const stepsChanged = !prev || prev.length !== curr.length || prev.some((s, i) => s !== curr[i]);
            if (stepsChanged) {
                this.maxVisitedStepIndex = 0;
                this.currentStepIndex = 0;
            }
        }
    }

    isStepClickable(index: number): boolean {
        if(!this.hasNavigation){
            return false;
        }
        if (index === this.currentStepIndex) {
            return false;
        }
        return index <= this.maxVisitedStepIndex;
    }

    isStepDone(index: number): boolean {
        if (!this.isStepCompleted) {
            return true;
        }
        return this.isStepCompleted(this.steps[index]);
    }

    goToStep(index: number): void {
        if (!this.isStepClickable(index)) {
            return;
        }
        this.currentStepIndex = index;
        this.stepIndexChangeListener.emit(index);
    }

    nextStep(): void {
        if (this.currentStepIndex === this.steps.length - 1) {
            this.submit.next();
            return;
        }
        this.currentStepIndex++;
        this.maxVisitedStepIndex = Math.max(this.maxVisitedStepIndex, this.currentStepIndex);
        this.stepIndexChangeListener.emit(this.currentStepIndex);
    }

    previousStep(): void {
        if (this.currentStepIndex === 0) {
            return;
        }
        this.currentStepIndex--;
        this.stepIndexChangeListener.emit(this.currentStepIndex);
    }
}
